__turbopack_context__.v({
  "social-logins-form": "NNK2Ra_social-logins-form",
  "social-logins-form__content": "NNK2Ra_social-logins-form__content",
  "social-logins-form__content--reduce-spacing": "NNK2Ra_social-logins-form__content--reduce-spacing",
  "social-logins-form__fieldset": "NNK2Ra_social-logins-form__fieldset",
  "social-logins-form__footer": "NNK2Ra_social-logins-form__footer",
  "social-logins-form__heading": "NNK2Ra_social-logins-form__heading",
  "social-logins-form__legend": "NNK2Ra_social-logins-form__legend",
  "social-logins-form__separator": "NNK2Ra_social-logins-form__separator",
  "social-logins-form__sub-heading": "NNK2Ra_social-logins-form__sub-heading",
});
